import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "section-row with-image" }
const _hoisted_2 = { class: "main-content-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "section-image-wrapper"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "content-side" }
const _hoisted_6 = { class: "top-content" }
const _hoisted_7 = { class: "section-title" }
const _hoisted_8 = { class: "row-value" }
const _hoisted_9 = {
  key: 1,
  class: "vertical-content"
}
const _hoisted_10 = { class: "row-value" }
const _hoisted_11 = { class: "bottom-content" }
const _hoisted_12 = { class: "row-price" }
const _hoisted_13 = {
  key: 1,
  class: "price-row"
}
const _hoisted_14 = { class: "row-price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.imageUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              class: _normalizeClass(["section-image", { floorplan: $props.isFloorplan }]),
              src: $props.imageUrl,
              alt: $props.title.toLowerCase()
            }, null, 10, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString($props.title), 1),
          ($setup.isUpgradeSection && $props.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.value, (upgrade, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "vertical-content",
                  key: upgrade._id
                }, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(upgrade.name), 1)
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString($props.value || "-"), 1)
              ]))
        ]),
        _createElementVNode("div", _hoisted_11, [
          ($setup.isUpgradeSection && $props.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.value, (upgrade, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "price-row",
                  key: upgrade._id
                }, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString($setup.formatPrice(upgrade.price)), 1)
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString($setup.formatPrice($props.price)), 1)
              ]))
        ])
      ])
    ])
  ]))
}